(function (module){
'use strict';
 module
    .controller('myProvidersController', ['$scope', 'organizationProviders','organizations', 'providers','$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'commonDialogMessage', '$filter', '$q', 'clientSelectService', 'agencySelectService',
      'toastr','orgFilterService',
      'currency', 'toastFactory', 'authService',
      function ($scope, organizationProviders, organizations, providers, $stateParams, progressBar, ngDialog, uiGridConstants,
        commonDialogMessage, $filter, $q, clientSelectService, agencySelectService, toastr, orgFilterService, currency, toastFactory,
        authService) {
		
		//variable declaration
        const progress = progressBar.getProgressBar();
		
        let _addProviderList = [];
        let _deleteProviderList = [];
        let _unassignedProviderSnapshot = [];
        let _assignedProviderSnapshot = [];

        function dialogBox(dialogMessage, dialogType) {
          ngDialog.open({
            template: dialogMessage + dialogType,
            className: 'ngdialog-theme-plain',
            plain: true,
          });
        }

        // Validate that filtered organization id is defined
        function validateOrganization() {
          const organization = clientSelectService.getSelectedClient();
          return organization.id != null && Number.isInteger(organization.id);
        };

        // Watch orgFilterService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return clientSelectService.getSelectedClient();
        }, function (newValue, oldValue) {

          if (newValue !== oldValue) {
            clearGrids();
            setGridData();
          }
        }, true);

        function clearGrids() {
          $scope.gridUnassignedProviders.data = [];
          $scope.gridUnassignedProviders.totalItems = 0;
          $scope.gridAssignedProviders.data = [];
          $scope.gridAssignedProviders.totalItems = 0;
          $scope.unassignedGridApi.grid.selection.selectAll = false;
          $scope.assignedGridApi.grid.selection.selectAll = false;
        };

       // function getTravelAgencyId(filterOrgId) {
         // return organizations.getOrganizationById(filterOrgId).then(function (organization) {
        //    return organization.data.TravelAgencyId;
        //  });
        //};

        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        // Sets both grids' data
        function setGridData() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            if (validateOrganization()) {
              progress.start();

              // Organization to assign/unassign travel agents to/from
              const filterOrg = clientSelectService.getSelectedClient();
              const filterOrgId = filterOrg.id;
              $scope.filterOrgName = filterOrg.name;

              // All agent from loginMember's travel agency
              const promiseAll = providers.getProviders();

              // Travel Agent Organizations for filtered organization
              const promiseAssigned = organizationProviders.getOrganizationProvidersByOrganizationId(filterOrgId);
			        const clientId = filterOrgId;
              $q.all([promiseAll, promiseAssigned]).then(function (responses) {
                if (responses[0].data.length > 0) {
                 // const travelAgencyId = responses[2];

                  // Processing
                  const assignedContext = processAssignedProviders(responses[0].data,responses[1].data);				  
                  const unassignedContext = processUnassignedProviders(responses[0].data, assignedContext,
                    clientId);					

                  // Populate grids
                  clearGrids();
                  $scope.gridUnassignedProviders.data = unassignedContext;
                  $scope.gridUnassignedProviders.totalItems = unassignedContext.length;
                  $scope.gridAssignedProviders.data = assignedContext;
                  $scope.gridAssignedProviders.totalItems = assignedContext.length;

                  // Save snapshots of initial grid data
                  _unassignedProviderSnapshot = $scope.gridUnassignedProviders.data.slice(0);
                  _assignedProviderSnapshot = $scope.gridAssignedProviders.data.slice(0);
                } else {
                  toastr.warning('No content received.', 'Alert');
                }
              }, function (err) {

                dialogBox(err.statusText, commonDialog.openDialog);
              }).finally(function () {
                progress.complete();
              });
            } else {
              $scope.filterOrgName = null;
            }
          } else if (valid.agencyValid) {
            //toastFactory.toast_info('Please select a client.');
          } else {
            //toastFactory.toast_info('Please select an agency and then client.');
          }
        };

        // Filter out assigned agents from all agents
        function processUnassignedProviders(allProvidersInfo, assignedProvidersInfo, clientId) {
          if (!!allProvidersInfo && !!assignedProvidersInfo) {
            // Grab MemberId's of assigned agents
            let assignedIds = _.map(assignedProvidersInfo, 'providerId');			
            return allProvidersInfo.filter(function (provider) {
              // Select members whose MemberId's are not in the assignedIds array
              if(assignedIds.length === 0){
                return allProvidersInfo;
              } else{
                return assignedIds.indexOf(provider.Id) < 0 && provider.OrganizationId === clientId;  
              } 
            }).map(function (provider) {
              return {
                ProviderId: provider.Id,
                ProviderName: provider.Name,
              };
            });
          }
        };

        // Only returns a projection
        function processAssignedProviders(allProvidersInfo,assignedProvidersInfo) {
          if ( !!allProvidersInfo && !!assignedProvidersInfo) {			  
            allProvidersInfo.forEach(function(allProviderObj) {
              assignedProvidersInfo.forEach(function(assignProviderObj) {
                if(allProviderObj.Id === assignProviderObj.ProviderId){
                  assignProviderObj.Name = allProviderObj.Name;
                }
              });
            });		
		        return assignedProvidersInfo.map(function (provider) {     
              return {
                Id: provider.Id,
                ProviderId: provider.ProviderId,
			          ProviderName: provider.Name,
                OrganizationId: provider.OrganizationId,
              };
            });			   
          }
        };

        // addTravelAgent and deleteTravelAgent should only act as purely visual functions --
        // the values sent to server will depend on diff from snapshotted data at time of action.
        $scope.addProvider = function () {
          _addProviderList.forEach(function (addProvider) {
            // Remove row from left
            $scope.gridUnassignedProviders.data.splice($scope.gridUnassignedProviders.data.indexOf(
              addProvider), 1);
            $scope.gridUnassignedProviders.totalItems--;

            // Push row to right
            $scope.gridAssignedProviders.data.push(addProvider);
            $scope.gridAssignedProviders.totalItems++;
          });

          // Clear _addTravelAgentList
          _addProviderList.length = 0;

          // Deselect left-side selectAll checkbox
          $scope.unassignedGridApi.grid.selection.selectAll = false;
        };

        $scope.deleteProvider = function () {
          _deleteProviderList.forEach(function (delProvider) {
            // Remove row from right
            $scope.gridAssignedProviders.data.splice($scope.gridAssignedProviders.data.indexOf(delProvider),
              1);
            $scope.gridAssignedProviders.totalItems--;

            // Push row to left
            $scope.gridUnassignedProviders.data.push(delProvider);
            $scope.gridUnassignedProviders.totalItems++;
          });

          // Clear _deleteTravelAgentList
          _deleteProviderList.length = 0;

          // Deselect right-side selectAll checkbox
          $scope.assignedGridApi.grid.selection.selectAll = false;
        };

        // Send changes to API
        $scope.saveProviders = function () {
          if (validateOrganization()) {
            const orgId = clientSelectService.getSelectedClient().id;

            // Check diffs against snapshots
            const toAdd = _.differenceWith($scope.gridAssignedProviders.data, _assignedProviderSnapshot, _.isEqual)
              .map(function (provider) {
                return {
				          OrganizationId: orgId,
                  ProviderId: provider.ProviderId                 
                };
              });
			  
            const toDelete = _.differenceWith($scope.gridUnassignedProviders.data, _unassignedProviderSnapshot, _.isEqual)
              .map(function (provider) {
                console.log(provider);
                console.log("lolololo");
                return {
                  //Id: provider.Id,
                };
              });

            const promiseAdd = organizationProviders.addOrganizationProviders(toAdd).then(function (response) {				 
                return !!response;
            });

            const promiseDel = organizationProviders.deleteOrganizationProvider(toDelete).then(function (response) {
              return !!response;
            });

            let promises = [];
            if (toAdd.length > 0) {
              promises.push(promiseAdd);
            }

            if (toDelete.length > 0) {
              promises.push(promiseDel);
            }

            if (promises.length > 0) {
              progress.start();
              $q.all(promises).then(function (responses) {
                progress.complete();
                if ((responses.length === 2 && responses[0] && responses[1]) || (responses.length === 1 && responses[0])) {
                  toastr.success('Changes were successfully made.', 'Success');
                  setGridData();
                } else {
                  toastr.error('An error occurred while making changes.', 'Error');
                }
              });
            } else {
              toastr.info('No changes were made.', 'Info');
            }
          }
        };

        // Resync grid data with server
        $scope.reset = function () {
          clearGrids();
          setGridData();
          _addProviderList.length = 0;
          _deleteProviderList.length = 0;
          if (validateOrganization()) {
            toastr.info('Grids were reset.', 'Reset');
          }
        };

        // ui-grid below        
        const columnDefs = [{
          name: 'ProviderName',
          displayName: 'Provider',
          visible: true,
          enableHiding: false,
          enableSorting: true,
          enableFiltering: true,
          enableColumnResizing: true,
          sort: {
            direction: uiGridConstants.ASC,
            priority: 0,
          },
        },];
        const gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: false,
          paginationPageSize: 10,
          useExternalPagination: false,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: true,
          enableRowHeaderSelection: true,
          multiSelect: true,
          enableSelectionBatchEvent: true,
          columnDefs: columnDefs,
        };
        /* TODO: enableFullRowSelection not working as intended:
        see https://github.com/angular-ui/ui-grid/issues/2254, https://github.com/angular-ui/ui-grid/commit/679b615bd19ff71ff1e835d7f6066e7a919f279a
        */

        // Left grid (Unassigned Agents)
        $scope.gridUnassignedProviders = _.cloneDeep(gridOptions);
        $scope.gridUnassignedProviders.onRegisterApi = function (gridApi) {
          $scope.unassignedGridApi = gridApi;
          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            if (row.isSelected) {
              _addProviderList.push(row.entity);
            } else {
              _addProviderList.splice(_addProviderList.indexOf(row.entity), 1);
            }
          });

          // Handle mass selection events
          gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
            _addProviderList = gridApi.selection.getSelectedRows();
          });
        };

        // Right grid (Assigned Agents)
        $scope.gridAssignedProviders = _.cloneDeep(gridOptions);
        $scope.gridAssignedProviders.onRegisterApi = function (gridApi) {
          $scope.assignedGridApi = gridApi;
          gridApi.selection.on.rowSelectionChanged($scope, function (row) {
            if (row.isSelected) {
              _deleteProviderList.push(row.entity);
            } else {
              _deleteProviderList.splice(_deleteProviderList.indexOf(row.entity), 1);
            }
          });

          // Handle mass selection events
          gridApi.selection.on.rowSelectionChangedBatch($scope, function (rows) {
            _deleteProviderList = gridApi.selection.getSelectedRows();
          });
        };
        // End ui-grid
        setGridData();		
		},
	]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/myProvidersController.js